module.exports = __webpack_public_path__ + "assets/img/s5-tab-4-active-87c3a122.png";